/* eslint-disable no-nested-ternary */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider, injectIntl } from 'react-intl';
import { AddressModal } from '../utils/AddressModal/AddressModal';
import CustomPindropSettingsForm from './CustomPindrop.settingsForm';
import Map from './Map/Map';
import './CustomPinDrop.scss';
import getLocalParams from '../localizationCustoms';

const CustomPinDrop = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      pindropError: false,
      value: props.value,
    };
    this.setShowModal = this.setShowModal.bind(this);
    this.setSubmitAddressMap = this.setSubmitAddressMap.bind(this);
    this.setSubmitAddressModal = this.setSubmitAddressModal.bind(this);
    this.formatedAddressCanada = this.formatedAddressCanada.bind(this);
    this.formatedAddressOthers = this.formatedAddressOthers.bind(this);
    this.pindropErrorHandling = this.pindropErrorHandling.bind(this);
  }

  setShowModal = (modalValue) => {
    this.setState({
      showModal: modalValue,
    });
  };

  setSubmitAddressMap = (address) => {
    const { props: { component: { useReviewLabel, reviewLabel, label }, onChange } } = this;
    let finalAddress = {};
    if (address.address.country === 'CA') {
      finalAddress = {
        street: address.address.street,
        streetName: address.address.streetName,
        city: address.address.city,
        province: address.address.province,
        postalCode: address.address.postalCode,
        country: address.address.country,
        value: address.value,
        coords: address.coords,
        url: address.url,
        review: { label: useReviewLabel ? reviewLabel : label },
      };
    } else {
      finalAddress = {
        street: address.address.street,
        streetName: address.address.streetName,
        city: address.address.city,
        state: address.address.state,
        zipCode: address.address.zipCode,
        country: address.address.country,
        value: address.value,
        coords: address.coords,
        url: address.url,
        review: { label: useReviewLabel ? reviewLabel : label },
      };
    }
    this.setState(
      {
        pindropError: false,
        value: finalAddress,
      },
      () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      },
    );
  };

  // eslint-disable-next-line class-methods-use-this
  formatedAddressCanada = (address) => {
    let fAddress = '';
    if (address.street !== '') {
      fAddress = fAddress.concat(`${address.street} `);
    }
    if (address.streetName !== '') {
      fAddress = fAddress.concat(`${address.streetName} `);
    }
    if (address.city !== '') {
      fAddress = fAddress.concat(`${address.city} `);
    }
    if (address.province !== '') {
      fAddress = fAddress.concat(`${address.province} `);
    }
    if (address.postalCode !== '') {
      fAddress = fAddress.concat(`${address.postalCode} `);
    }
    if (address.country !== '') {
      fAddress = fAddress.concat(address.country);
    }
    return fAddress;
  };

  // eslint-disable-next-line class-methods-use-this
  formatedAddressOthers = (address) => {
    let fAddress = '';
    if (address.street !== '') {
      fAddress = fAddress.concat(`${address.street} `);
    }
    if (address.streetName !== '') {
      fAddress = fAddress.concat(`${address.streetName} `);
    }
    if (address.city !== '') {
      fAddress = fAddress.concat(`${address.city} `);
    }
    if (address.state !== '') {
      fAddress = fAddress.concat(`${address.state} `);
    }
    if (address.zipCode !== '') {
      fAddress = fAddress.concat(`${address.zipCode} `);
    }
    if (address.country !== '') {
      fAddress = fAddress.concat(address.country);
    }
    return fAddress;
  };

  setSubmitAddressModal = (address) => {
    const { props: { component: { useReviewLabel, reviewLabel, label }, onChange } } = this || null;
    let finalAddress = {};
    if (address.country === 'CA') {
      finalAddress = {
        value: this.formatedAddressCanada(address),
        street: address.street,
        streetName: address.streetName,
        city: address.city,
        province: address.province,
        postalCode: address.postalCode,
        country: address.country,
        review: { label: useReviewLabel ? reviewLabel : label },
      };
    } else {
      finalAddress = {
        value: this.formatedAddressOthers(address),
        street: address.street,
        streetName: address.streetName,
        city: address.city,
        state: address.state,
        zipCode: address.zipCode,
        country: address.country,
        review: { label: useReviewLabel ? reviewLabel : label },
      };
    }

    this.setState(
      {
        pindropError: false,
        showModal: false,
        value: finalAddress,
      },
      () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      },
    );
  };

  pindropErrorHandling = () => {
    this.setState(
      {
        pindropError: true,
      },
    );
  };

  render() {
    const { state: { value, showModal, pindropError }, props: { component: { label, tooltip, hideCustomLabel, tooltipTitle }, intl, localParams }, disabled, setSubmitAddressMap, setShowModal, setSubmitAddressModal, pindropErrorHandling } = this;
    const renderMap = (value === null || typeof value === 'undefined') || (value && Object.prototype.hasOwnProperty.call(value, 'coords'));
    return (
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <div className={`pindrop ${pindropError ? 'opened-error' : renderMap ? value ? 'opened-shrinked' : 'opened' : 'closed'}`}>
          {!hideCustomLabel && (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <label htmlFor="textareaPindrop" className="label-question question-no-margin">
                <FormattedMessage id={label} defaultMessage={label} />
              </label>
              {tooltip !== '' && (
              <Tooltip id="tooltip_textareaPindrop" primary title={tooltipTitle ? intl.formatMessage({ id: tooltipTitle, defaultValue: tooltipTitle }) : ''}>
                <FormattedMessage id={tooltip} defaultMessage={tooltip} />
              </Tooltip>
              )}
            </div>
          )}
          {renderMap ? (
            <div className={`map ${value ? 'shrinked' : pindropError ? 'expandedWithError' : 'expanded'}`}>
              <Map
                disabled={disabled}
                value={value}
                setSubmitAddressMap={setSubmitAddressMap}
                setSubmitAddressModal={setSubmitAddressModal}
                pindropErrorHandling={pindropErrorHandling}
                localParams={localParams}
              />
            </div>
          ) : null}
          <div className={`textAreaPindrop ${renderMap ? value ? 'expanded' : 'empty' : 'shrinked'}`}>
            <AddressModal
              type="Pindrop"
              showModal={showModal}
              setShowModal={setShowModal}
              setSubmitAddressModal={setSubmitAddressModal}
              localParams={localParams}
            />
            {value ? (
              <textarea
                disabled
                style={{ fontSize: '16px' }}
                className="pindropTextbox"
                type="text"
                id="textareaPindrop"
                value={`${intl.formatMessage({ id: 'Selected incident location:', defaultValue: 'Selected incident location:' })} ${value.value}`}

              />
            ) : null}
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {renderMap
                ? (
                  <>
                    {pindropError ? (
                      <span className="errorText">
                        <FormattedMessage id="Uh oh! We're having trouble with our map tool. Please" defaultMessage="Uh oh! We're having trouble with our map tool. Please" /> <button type="button" onClick={() => setShowModal(true)} className="addLocation"> <FormattedMessage id="add location" defaultMessage="add location" /></button>  <FormattedMessage id="manually." defaultMessage="manually." />
                      </span>
                    ) : null}
                    <span className="findAddress">
                      <FormattedMessage id={'Can\'t find the right address?'} defaultMessage={'Can\'t find the right address?'} />
                    </span>
                  </>
                )
                : null}
              <button
                type="button"
                className="addLocation"
                onClick={() => setShowModal(true)}
              >
                <FormattedMessage id={renderMap ? 'Add location' : 'Edit location'} defaultMessage={renderMap ? 'Add location' : 'Edit location'} />
              </button>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
};

const CustomPinDropWithIntl = injectIntl(CustomPinDrop);

export default class PinDropComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom PinDrop',
      group: 'advanced',
      icon: 'map',
      documentation: '',
      schema: PinDropComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'custompindrop',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomPindropSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomPinDropWithIntl
          inputRef={(refer) => {
            instance = refer;
          }}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          onChange={this.updateValue} // The onChange event to call when the value changes.
          localParams={localParams}
        />
      </IntlProvider>,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
